var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('b-card',{attrs:{"title":"Список эталонов"}},[_c('b-button',{on:{"click":_vm.openReferenceList}},[_vm._v(" Показать список эталонов ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }